import { createAction } from "@reduxjs/toolkit";

export const getAnalysisSuccess = createAction("analysis/getSuccess")
export const getAnalysisError = createAction("analysis/getError")
export const getAnalysisRequest = createAction("analysis/getRequest")
export const loadMoreRequest = createAction("analysis/loadMoreRequest")
export const setEmpty = createAction("analysis/setEmpty")
export const bookAnalysisSuccess = createAction('analysis/bookAnalysisSuccess')
export const getLaboratoriesSuccess = createAction("analysis/getLaboratoriesSuccess")
export const clearAnalysis = createAction('analysis/clearAnalysis')